import { render, staticRenderFns } from "./ConfirmEditNameModal.vue?vue&type=template&id=70a7a517&scoped=true&"
import script from "./ConfirmEditNameModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmEditNameModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEditNameModal.vue?vue&type=style&index=0&id=70a7a517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7a517",
  null
  
)

export default component.exports